<template>
  <div class="coupons-tab">
    <h1>{{customer.isrd_nm?customer.isrd_nm:''}} Coupons</h1>

    <div class="filter-container">
      <div class="filter-box">
        <span class="label">Add Coupon</span>
        <div class="search-box flex">
          <v-select
            v-model="coupon_code"
            placeholder="Coupon Title - COUPONCODE"
            remote
            noList
            :remoteMethod="remoteMethod"
            :list="useCouponList"
            :labelKey="'title'"
            :labelSecondKey="'coupon_code'"
            :valueKey="'coupon_code'"
            @focus="handleFocus"
          />
          <div class="add-margin">
            <v-button
              size="small"
              type="primary"
              @click="handlerAddUse"
            >Add</v-button>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">

      <template v-if="can_use.length>0">
        <div class="coupon-body">
          <div
            v-for="(item,index ) in can_use"
            :key="index"
            class="coupon-content"
            :class="select==index?'is-check-coupon':''"
            @click="handlerSelect(item,index)">
            <div>
              <span class="coupon-title">{{item.title}}</span>
              <span class="coupon-code">{{item.coupon_code}}</span>
              <div class="coupon-mark">
                <span>{{item.description}}</span>
              </div>
            </div>
            <div>
              <span>{{item.unlimited_users==0?'Once ':'Unlimited'}} uses</span>

              <div
                v-if="select==index"
                class="flex select-icon">
                <span>Selected</span>
                <i class="el-icon-check"></i>
              </div>
              <div
                v-else
                class="flex">
                <span>Expires {{handTime(item.end_time)}}</span>
                <font-awesome-icon
                  v-if="hasDelete"
                  icon="trash"
                  class="icon"
                  @click="handlerDelete(item.user_coupon_id,index,'can_use')"></font-awesome-icon>
              </div>

            </div>
          </div>
        </div>
      </template>
      <template v-if="inactive.length>0">
        <h3>Inactive Coupons</h3>
        <div class="coupon-body">
          <div
            v-for="(item,index ) in inactive"
            :key="'inactive'+index"
            class="coupon-content"
            :class="select==index?'is-check-coupon':''"
            @click="handlerSelect(item,index)">
            <div>
              <span class="coupon-title">{{item.title}}</span>
              <div class="coupon-mark">
                <span>{{item.description}}</span>
              </div>
            </div>
            <div>
              <span>{{item.unlimited_users==0?'Once ':'Unlimited'}} uses</span>

              <div
                v-if="select==index"
                class="flex select-icon">
                <span>Selected</span>
                <i class="el-icon-check"></i>
              </div>
              <div
                v-else
                class="flex">
                <span>Expires {{handTime(item.end_time)}}</span>
                <font-awesome-icon
                  v-if="hasDelete"
                  icon="trash"
                  class="icon"
                  @click="handlerDelete(item.user_coupon_id,index,'inactive')"></font-awesome-icon>
              </div>

            </div>
          </div>
        </div>
      </template>
      <template v-if="used.length>0">
        <h3>Used Coupons</h3>
        <div class="coupon-body">
          <div
            v-for="(item,index ) in used"
            :key="'used'+index"
            class="coupon-content"
            :class="select==index?'is-check-coupon':''"
            @click="handlerSelect(item,index)">
            <div>
              <span class="coupon-title">{{item.title}}</span>
              <div class="coupon-mark">
                <span>{{item.description}}</span>
              </div>
            </div>
            <div>
              <span>{{item.unlimited_users==0?'Once ':'Unlimited'}} uses</span>

              <div
                v-if="select==index"
                class="flex select-icon">
                <span>Selected</span>
                <i class="el-icon-check"></i>
              </div>
              <div
                v-else
                class="flex">
                <span>Expires {{handTime(item.end_time)}}</span>
                <font-awesome-icon
                  v-if="hasDelete"
                  icon="trash"
                  class="icon"
                  @click="handlerDelete(item.user_coupon_id,index,'used')"></font-awesome-icon>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import {addUserCoupon, deleteUserCoupon, getCouponCategory, getUseCouponList, orderUseCoupon} from '@/api/coupon'
import {mapState} from 'vuex'
import coupon from '@/store/coupon'

export default {
  name: 'couponCategory',
  mixins: [MixinOptions],
  props: {
    // customerId: [String, Number],
    hasDelete:{
      type:Boolean,
      default:true
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    orderId:[String, Number],
  },
  inject: ['customer_id'],
  data() {
    return {
      tableData: [],
      useCouponList:[],
      coupon_code:'',
      select:-1,
      timer: null
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode']),
    customerId(){
      return this.customer_id()
    },
    can_use(){
      let {can_use} = this.tableData
      return can_use||[]
    },
    inactive(){
      let {inactive} = this.tableData
      return inactive||[]
    },
    used(){
      let {used} = this.tableData
      return used||[]
    },
  },
  watch:{
    // couponCode:{
    //   immediate:true,
    //   handler(val) {
    //     if(!val)this.select =-1
    //     else {
    //       this.tableData.filter((item,index)=>{
    //         if(val==item.coupon_code){
    //           this.select = index
    //         }
    //       })
    //     }
    //   }
    // }
  },
  created() {
    this.network().getUseCouponList()
    this.network().getUserCouponList()
  },
  methods: {
    handlerDelete(coupon_id,index,name){
      this.network().deleteUserCoupon(coupon_id,index,name)
    },
    handTime(time){
      if(time){
        return  dayjs(time).format('DD MMM YYYY')
      }else return '-'
    },
    handlerAddUse(){
      this.network().addUserCoupon()
    },
    handlerSelect(item,index){
      if(this.hasDelete)
        return
      if(this.select==index){
        this.select =-1
        this.$emit('coupon',{})
      }else {
        this.select = index
        this.$emit('coupon',item)
      }

    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getUserCouponList()
    },
    remoteMethod(query){
      let params = {
        search_text: query,
        hideLoading: true
      }
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.network().getUseCouponList(params)
      }, 500)
    },

    handleFocus(){
      this.useCouponList = []
    },

    network() {
      return {
        //获取用户优惠券列表
        getUserCouponList: async () => {
          let list
          if(!this.hasDelete)
          {
            list = await orderUseCoupon({
              user_id:this.customerId,
              order_id:this.orderId
            })
          }else
            list = await getCouponCategory({
              user_id:this.customerId
            })
          let {data} =list
          this.tableData = data

        },
        //删除用户优惠券
        deleteUserCoupon: async (params,index,name) => {
          const { data } = await deleteUserCoupon({
            user_id:this.customerId,
            user_coupon_id:params
          })
          this.tableData[name].splice(index,1)
        },
        //可使用列表
        getUseCouponList: async (params) => {
          let {data} = await getUseCouponList({
            order_id:this.orderId,
            ...params
          })
          this.useCouponList =data
        },

        //用户添加优惠券
        addUserCoupon: async () => {
          const { data } = await addUserCoupon({
            user_id:this.customerId,
            coupon_code: this.coupon_code
          })
          this.network().getUserCouponList()
        },

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coupons-tab {
  position: relative;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 16px;
  }
  h3{
    padding-bottom: 0px!important;
    border-top: 1px solid #e1e4e8;
    padding-top: 16px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409EFF;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
      .add-margin{
        margin-left: 16px;
      }
    }
  }
  .coupon-body{
    margin: 24px 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .coupon-content{
      background: #fff;
      padding: 16px;
      margin: 0 16px 16px 0;
      border-radius: 4px;
      width: 200px;
      height: 150px;
      border:1px solid #D1D5DA;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .coupon-title{
        color:#24292E;
        font-size:16px!important;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .coupon-code{
        height: 18px;
        line-height: 18px;
        display: inline-block;
      }
      span{
        color: #6A737D;
        font-size: 12px;
      }
      .coupon-mark{
        margin-top: 5px;
        overflow: hidden;
        span{
          text-overflow: ellipsis;
          word-break: break-word;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .flex{
        justify-content: space-between;
        .icon{
          color: #CB2431;
          font-size: 12px;
        }
      }
    }
    .is-check-coupon{
      border: 1px solid #28A745;
      .select-icon{
        color:#28A745;
        font-weight: bold;
      }
    }

  }
}
</style>
